import Vue from 'vue'
import './plugins/vuetify'
import './plugins/globalComponents'
import '@/stylus/main.styl'
import App from './App.vue'
import router from './router'
import store from './store'
import AsyncComputed from 'vue-async-computed';
//import Helper from '@/store/computed/storeHelpers'
import { isEqual } from 'lodash'
import VueWorker from 'vue-worker'

Vue.config.productionTip = false

Vue.use(AsyncComputed)
Vue.use(VueWorker)
//Vue.prototype.$moment = Moment
//Vue.prototype.$helpers = Helper
Vue.prototype._ = { isEqual }
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

